import React, {useState} from "react";
import right4 from "../../img/right-4@2x.svg";
import Route from "../Route";
import Link from "../Link";
import PersonalInfo from "../PersonalInfo";
import { useAuth0 } from "@auth0/auth0-react";
import "./UserName.css";

function UserName() {
  const [userOptions, setUserOptions] = useState("")

  const { loginWithPopup, loginWithRedirect, logout, user, isAuthenticated} = useAuth0();

  const editProfile = (userChoice) => {
    if(userChoice === '/profile'){
      console.log(userChoice);
      <Link href={userChoice} ></Link>
    } else {
      console.log(userChoice);
      <Link href='/dashboard'></Link>
    }
    return editProfile;
  }

  return (
    <div className="user-name">
      <div className="user-name-1 nunito-bold-silver-12px">
        {user.name}
      </div>
      <button className="logout-button nunito-semi-bold-haiti-11-7px " onClick={logout}>logout</button>
      {/* <select className="right-48" src={right4} onChange={(e) => {
        const userChoice = e.target.value
        setUserOptions(userChoice);
        <Link href={userChoice} />
        editProfile(userChoice);
      }}>
        <option value=""></option>
        <option value="/profile">Edit Profile</option>
        <option value="signOut">Sign Out</option>
      </select> */}
      <img
        src={user.picture}
        alt="Profile Picture"
        className="profile-picture"
      />
    </div>
  );
}

export default UserName;
